import { BaseComponent } from '../../base-component';
import type { VideoPlayer, VideoPlayerConfig } from './video-player';
import { initVideoPlayer } from '../../_common/client/nexus-interfaces/video';

export class VideoComponent extends BaseComponent {
    public rootSelector = '.js_pdp_video';

    private viewerVersion = '';

    public async init(): Promise<void> {
        initVideoPlayer.assignFunction(config => this.initPlayer(config));
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.viewerVersion = this.getRootElement().dataset.viewerVersion || '';
    }

    private async initPlayer(config: VideoPlayerConfig): Promise<VideoPlayer> {
        const { VideoPlayer } = await import('./video-player');
        const videoPlayer = new VideoPlayer(config);
        await videoPlayer.init(this.viewerVersion);
        return videoPlayer;
    }
}
